import { render } from "./Detail.vue?vue&type=template&id=1b836e42&scoped=true&bindings={}"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=1b836e42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b836e42"

export default script